import type { ButtonHTMLAttributes, ReactNode } from "react";
import { useCanManageCertificaciones } from "../permissions/useCertificationPermissions";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string;
  icon: ReactNode;
  danger?: boolean;
  requiresManage?: boolean;
};

export function CertificationIconButton({
  label,
  icon,
  danger = false,
  requiresManage = true,
  className = "",
  type = "button",
  ...props
}: Props) {
  const canManage = useCanManageCertificaciones();

  if (requiresManage && !canManage) {
    return null;
  }

  return (
    <button
      type={type}
      title={label}
      aria-label={label}
      className={`iso27001-icon-button ${danger ? "danger" : ""} ${!requiresManage ? "certification-icon-button-always-visible" : ""} ${className}`.trim()}
      {...props}
    >
      {icon}
    </button>
  );
}
